/**
 * The amount of degrees in circle
 * @type {Number}
 */
export const CIRCLE_DEGREES = 360;

/**
 * The gradient angle start point ratio
 * @type {Number}
 */
export const START_POINT_RATIO = CIRCLE_DEGREES / 4;

/**
 * The gradient angle end point ratio
 * @type {Number}
 */
export const END_POINT_RATIO = CIRCLE_DEGREES * (3 / 4);

/**
 * The epsilon representation
 * @type {Number}
 */
export const EPSILON = Math.pow(2, -52);
